import * as React from "react"
import { cn } from "@/lib/utils"

interface AIMessageProps extends React.HTMLAttributes<HTMLDivElement> {
  content: string
  avatarUrl?: string
}

const AIMessage = React.forwardRef<HTMLDivElement, AIMessageProps>(
  (
    {
      content,
      avatarUrl = "https://lh3.googleusercontent.com/aida-public/AB6AXuC6CepGudmQNiTvazb7-vXgg_x5jtIsmbG1PiIwlsX6s9QJqsF3dRB5G6DA-tu9a7p6hnsszc9pyyCx-kTuHNRk66BoKdhRaZAH4Vjz5U8s_ri3xQolK0gTuNkadjC-Zqb8-s2B-PieUsHQYC4rC2YqPO8tDsCtT0wmyWqyRtC96LWJMpP75r0OVCrsjxsqeiSLJ_ccuROQP6PJG4uJhE7-dtjB0RJFxPuM2FHzecLHqjilOHjAUOu2AnjNXi6mGsbF4s9vvQYXgXM",
      className,
      ...props
    },
    ref,
  ) => (
    <div ref={ref} className={cn("flex items-start gap-4", className)} {...props}>
      <img
        alt="EarlyScape AI assistant avatar"
        className="w-12 h-12 rounded-full border-2 border-cyan-500 flex-shrink-0"
        src={avatarUrl || "/placeholder.svg"}
      />
      <div className="bg-gray-100 rounded-lg rounded-tl-none p-4 max-w-md">
        <p className="font-bold text-blue-600 mb-1">EarlyScape AI</p>
        <p className="text-sm text-gray-800">{content}</p>
      </div>
    </div>
  ),
)
AIMessage.displayName = "AIMessage"

export { AIMessage }
